import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import landingpageimage from "../../../Components/assets/Images/nriHeroImageNew.svg";
import routesData from "../../../shared/routes.json";
import SignupStyles from "./LandingPage1.module.scss";
import LandingPage2 from "../LandingPage2/LandingPage2";
import LandingPage3 from "../LandingPage3/LandingPage3";
import FAQ from "../FAQ/FAQ";
import { IAdminLogin } from "../../../shared/dtos";
import { AdminLoginToClientAccountAPICall } from "../../../shared/APICalls";
import SnackBar from "../../../Components/SnackBars/SnackBar";

export default function LandingPage() {
  const navigationData = routesData;
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const source = Object.keys(params)[0];
  const id = (params.c && params.c) || (params.p && params.p);
  const client_id = params.client_id;
  const user_id = params.user_id;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (client_id && client_id) {
      let obj: IAdminLogin = {
        client_id: client_id,
        admin_id: user_id,
      };

      AdminLoginToClientAccountAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          // console.log("responseData", responseData.data.access_token);
          sessionStorage.setItem(
            "access-token",
            responseData.data.access_token
          );
          if (
            responseData.data.next_stage &&
            navigationData.hasOwnProperty(responseData.data.next_stage)
          ) {
            navigate(navigationData[responseData.data.next_stage]);
          }
        })
        .catch((error: any) => {
          setMessage(error.response.data.message);
          setTimeout(() => {
            setMessage("");
          }, 5000);
        });
    }
  }, [client_id, user_id]);

  return (
    <>
      <SnackBar message={message} />
      <div className={SignupStyles.wrapper}>
        <div className={SignupStyles.leftContainer}>
          <img src={landingpageimage} className={SignupStyles.video} />
        </div>
        <div className={SignupStyles.RightContainer}>
          <div className={SignupStyles.headerSection}>
            <p className={SignupStyles.signup}>
              Begin Your Global <br />
              Investing with <br />
              Firstock{" "}
            </p>

            <p className={SignupStyles.subText}>
              Hassle-Free Onboarding as a Non-Resident Indian. Uncover the
              myriad opportunities and advantages Firstock offers for your
              global investment journey.
            </p>
            <div className={SignupStyles.buttonSection}>
              <div
                className={SignupStyles.getStartedButton}
                onClick={() => {
                  navigate("/email");
                }}
              >
                Get Started{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M9.33333 3.33594L14 8.0026M14 8.0026L9.33333 12.6693M14 8.0026L2 8.0026"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingPage2 />
      <LandingPage3 />
      <FAQ />
    </>
  );
}
